<template>
  <div class="shop">
    <div class="search-area disFlex fc" @click="chooseFlag = false">
      <div class="name-area disFlex fc">
        <div class="name" @click.stop.prevent="changeBrands">{{currentName}}</div>
        <img src="https://j.weizan.cn/youxiang/down-arrow.png" class="down-arrow" />
      </div>
      <div class="input-area disFlex fc">
        <img src="https://j.weizan.cn/youxiang/search-icon.png" class="search-icon" />
        <input type="text" placeholder="搜索你喜欢的门店" v-model="searchBrandName" />
        <div class="btn" @click.stop.prevent="keyWordSearch">搜索</div>
      </div>
    </div>
    <div class="banner">
      <img :src="shopPageInfo.logo" class="banner" />
    </div>
    <van-notice-bar
      background="rgba(255,223,180,1)"
      scrollable
      color="#AC7B3A"
      :text="shopPageInfo.notice"
    ></van-notice-bar>
    <div class="shop-area" v-for="(brand,index) in brandShopList" :key="index">
      <shop-item
        v-for="(shop,idx) in brand.shopList"
        :key="idx"
        :item="shop"
        :index="idx"
        :logo="brand.brand.brandLogo"
        v-show="brand.showType==='all'||idx===0&&brand.showType==='one'"
      ></shop-item>
      <div
        class="shop-group-info f fc fbt"
        @click.stop.prevent="changeBrandShowType(index)"
        v-if="brand.showType==='one'&&brand.shopList.length>1"
      >
        <div class="info-left">
          门店共计
          <span class="num">{{brand.shopList.length}}</span>个
        </div>
        <div class="f fc info-right">
          展开
          <img src="https://j.weizan.cn/youxiang/down-arrow.png" class="up-arrow" />
        </div>
      </div>
      <div class="line"></div>
    </div>

    <div class="choose-area" v-if="chooseFlag">
      <div
        class="choose-item"
        v-for="item in brandList"
        :key="item.id"
        @click.stop.prevent="selectBrand(item)"
      >{{item.name}}</div>
    </div>
  </div>
</template>

<script>
import BottomNav from "./../../components/bottom-nav";
import ShopItem from "./../../components/shop-item";

export default {
  components: {
    BottomNav,
    ShopItem,
  },
  data() {
    return {
      chooseFlag: false,
      shopPageInfo: {},
      brandShopList: [],
      brandList: [
        {
          id: null,
          name: "全部门店",
        },
      ],
      searchBrandName: "",
      searchBrandId: null,
      showType: "all",
      currentName: "全部门店",
    };
  },
  created() {
    this.$initWXSDK(
      {
        openShare: true,
      },
      () => {
        this.$utils.getLocation().then((res) => {});
      }
    );
    this.$store.commit("setLoading", true);
    this.getshopPageInfo();
    this.getAllBrands();
  },
  methods: {
    keyWordSearch() {
      this.currentName = this.searchBrandName;
      this.searchBrandId = null;
      this.search();
    },
    search() {
      this.chooseFlag = false;
      this.$http
        .post("/v1/home/shop/list_with_brand", {
          actId: localStorage.getItem("act_id"),
          brandId: this.searchBrandId,
          name: this.searchBrandName,
          page: 1,
          size: -1,
        })
        .then((res) => {
          this.shopPageInfo = res.data;
          this.brandShopList = res.data.brandShopList;
          this.showType = res.data.showType || "all";
          this.brandShopList.forEach((i) => {
            i.showType = this.showType;
          });
        });
    },
    selectBrand(item) {
      this.currentName = item.name;
      this.searchBrandLogo = item.brandLogo;
      this.searchBrandName = null;
      this.searchBrandId = item.id;
      this.chooseFlag = false;
      this.search();
    },
    getAllBrands() {
      this.$http
        .post("/v1/home/brand/list", {
          actId: localStorage.getItem("act_id"),
          name: "",
          page: -1,
          size: -1,
        })
        .then((res) => {
          this.brandList = this.brandList.concat(res.data.list);
        });
    },
    changeBrands() {
      this.chooseFlag = !this.chooseFlag;
    },
    changeBrandShowType(i) {
      let tmp = this.brandShopList.slice(0);
      tmp[i].showType = "all";
      this.brandShopList = tmp;
    },
    getshopPageInfo() {
      this.$http
        .post("/v1/home/shop/list_with_brand", {
          actId: localStorage.getItem("act_id"),
          brandId: null,
          name: null,
          page: 1,
          size: -1,
        })
        .then((res) => {
          this.$store.commit("setLoading", false);

          this.shopPageInfo = res.data;
          this.brandShopList = res.data.brandShopList;
          this.showType = res.data.showType || "all";
          this.brandShopList.forEach((i) => {
            i.showType = this.showType;
          });
        });
    },
  },
};
</script>
<style lang="less" scoped>
.shop {
  padding-bottom: 65px;
  min-height: 100vh;
  background: #fff;
  .line {
    width: 100%;
    height: 3px;
    background: rgba(245, 246, 247, 1);
  }
  .search-area {
    padding: 10px 0 15px;
    .name-area {
      padding: 0 15px;
      width: 28%;
    }
    .name {
      font-size: 12px;
      font-family: PingFang SC;
      font-weight: 500;
      color: rgba(53, 53, 53, 1);
    }
    .input-area {
      height: 33px;
      background: rgba(245, 246, 247, 1);
      border-radius: 17px;
      padding: 0 15px;
    }
    .search-icon {
      width: 14px;
      height: 14px;
      margin-right: 14px;
    }
    input {
      width: 180px;
      font-size: 12px;
      font-family: PingFang SC;
      font-weight: 500;
      color: rgba(190, 190, 190, 1);
      line-height: 24px;
      background: rgba(245, 246, 247, 1);

      border: none;
    }
    .btn {
      font-size: 12px;
    }
  }
  .banner {
    width: 100%;
    height: 211px;
    background: rgba(216, 216, 216, 1);
  }
  .shop-group-info {
    padding: 0 15px 14px;
    .info-left {
      font-size: 12px;
      font-family: PingFang SC;
      font-weight: 500;
      color: rgba(116, 116, 116, 1);
      .num {
        color: #003078;
      }
    }
    .info-right {
      font-size: 12px;
      font-family: PingFang SC;
      font-weight: 500;
      color: rgba(0, 48, 120, 1);
      .up-arrow {
        width: 11px;
        height: 7px;
        margin-left: 4px;
      }
    }
  }
  .choose-area {
    overflow-y: scroll;
    width: 100%;
    height: calc(100vh - 58px - 44px);
    background: #fff;
    position: fixed;
    left: 0;
    top: 58px;
    .choose-item {
      font-size: 12px;
      font-family: PingFang SC;
      font-weight: 500;
      color: rgba(116, 116, 116, 1);
      padding: 15px 0;
      margin: 0 15px;
      border-bottom: 1px solid #f5f6f7;
    }
  }
  .down-arrow {
    position: relative;
    top: 2px;
    left: 5px;
  }
}
.van-notice-bar {
  height: 30px !important;
}
</style>